import IndividualCircularLoader from '../../../../components/Loader/IndividualCircularLoader';
import useSubscription from '../../hooks/useSubscription';

import styles from './registrationGeographicSectors.module.scss';

const RegistrationGeographicSectors = () => {
  const { subscriptionCities, subscriptionDepartments, subscriptionStatusPending } =
    useSubscription();

  return (
    <div className={styles.container}>
      <h3>Secteurs géographiques</h3>

      <div className={styles.lists}>
        <div>
          <h4>Villes</h4>
          {subscriptionStatusPending ? (
            <IndividualCircularLoader size={50} />
          ) : (
            <ul className={styles.list}>
              {subscriptionCities?.map((city) => (
                <li className={styles.lowMargin} key={city.idIri}>
                  {city.name}
                </li>
              )) ?? <IndividualCircularLoader size={50} />}
            </ul>
          )}
        </div>
        <div>
          <h4>Départements</h4>
          {subscriptionStatusPending ? (
            <IndividualCircularLoader size={50} />
          ) : (
            <ul className={styles.list}>
              {subscriptionDepartments?.map((department) => (
                <li className={styles.lowMargin} key={department.idIri}>
                  {department.name}
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};

export default RegistrationGeographicSectors;
